import VueFinalPopover from './VueFinalPopover.vue'
import PopoversContainer from './PopoversContainer.vue'
import { shallowReactive } from 'vue'

export function defineApi() {
  let _modalComponent = null

  return {
    /**
     * Hiển thị popover
     * @param {*} modal popover object
     * @param  {...any} args tham số
     */
    show(modal, ...args) {
      // Nếu bấm và target element thì ko làm j cả
      if (args.length) {
        if (this.modals.findIndex(modal => modal.params?._rawValue?.target === args[0].target) >= 0) {
          return;
        }
      }
      switch (typeof modal) {
        case 'string':
          return this.toggle(modal, true, ...args)
        case 'object': {
          return Promise.allSettled([
            new Promise((resolve, reject) => {
              const defaultModal = {
                value: true,
                id: Symbol('dynamicModal'),
                component: _modalComponent,
                // bind prop target tới VueFinalPopover
                bind: {
                  target: args[0].target
                },
                slots: {},
                on: {},
                params: args[0],
                reject,
                opened() {
                  resolve('show')
                }
              }
              this.dynamicModals.push(shallowReactive(Object.assign(defaultModal, modal)))
            })
          ])
        }
      }
    },
    /**
     * Ẩn popover hiện tại
     * @param  {...any} names Tên popover
     */
    hide(...names) {
      return this.toggle(names, false)
    },
    /**
     * Ẩn tất cả popover
     */
    hideAll() {
      return this.hide(...this.openedModals.map(modal => modal.props.name))
    },
    /**
     * Ẩn hiện popover theo tên
     * @param {*} name Tên popover
     * @param  {...any} args tham số
     */
    toggle(name, ...args) {
      const modals = Array.isArray(name) ? this.get(...name) : this.get(name)
      return Promise.allSettled(modals.map(modal => modal.toggle(...args)))
    },
    /**
     * Lấy danh sách popover theo tên
     * @param  {...any} names Tên popover
     */
    get(...names) {
      return this.modals.filter(modal => names.includes(modal.props.name))
    },
    dynamicModals: shallowReactive([]),

    /**
     * Danh sách các popover đang mở
     */
    openedModals: [],

    /**
     * Danh sách các popover
     */
    modals: [],

    /**
     * Bind popover component vào class hiện tại
     * @param {*} modalComponent popover component
     */
    _setDefaultModal(modalComponent) {
      _modalComponent = modalComponent
    }
  }
}

/**
 * Bind api vào component
 * @param {*} component compnent để bind api vào
 * @param {*} api api cho component dùng
 */
function bindApi(component, api) {
  const _component = { ...component, props: { ...component.props } }
  Object.assign(_component.props, {
    api: { type: Object, default: () => api }
  })
  return _component
}

/**
 * Bind api vào popover
 * @param {*} api api popover dùng
 */
export function defineModal(api) {
  const modalComponent = bindApi(VueFinalPopover, api)
  api._setDefaultModal(modalComponent)
  return modalComponent
}

/**
 * Bind api vào container của popover
 * @param {*} api api popover dùng
 */
export function defineContainer(api) {
  return bindApi(PopoversContainer, api)
}
